import { DWDialogTableCheck } from 'src/components/dialog-table-check';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWDialogTableCheck.displayName, DWDialogTableCheck);

export default DWDialogTableCheck;
export { DWDialogTableCheck };
